import "reflect-metadata";
import {inject, injectable} from "inversify";
import {PlanExtensionsCatalogRepository} from "@dropDesk/domain/repositories/plan_extensions/plan_extensions_catalog.repository";
import {PlanExtensionCatalogEntity} from "@dropDesk/domain/entities/plan_extensions/plan_extension_catalog.entity";

@injectable()
export class ListCatalogPlanExtensionsUseCase {
    private _repository: PlanExtensionsCatalogRepository;

    constructor(@inject(PlanExtensionsCatalogRepository) repository: PlanExtensionsCatalogRepository) {
        this._repository = repository;
    }

    public call(includeDeleted?: boolean): Promise<PlanExtensionCatalogEntity[]> {
        return this._repository.listCatalog(includeDeleted);
    }
}
